import React, { useState, useContext } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { AuthContext } from "../../helpers/auth";
import { Link } from "react-router-dom";

const Sidebar = () => {
  const [isActive, setActive] = useState(false);
  const auth = useContext(AuthContext);

  if (!auth.meta.id) {
    return null;
  }

  const userType = auth.meta.user_type;

  const initials = auth.meta.short_name
    .split(" ")
    .map((word) => word[0])
    .join("")
    .toUpperCase();

  return (
    <div
      className={"sidebar" + (isActive ? " is-active" : "")}
      onClick={() => setActive(!isActive)}
    >
      <div className="sidebar-item is-disabled">
        <span className="sidebar-label">{auth.meta.short_name}</span>
        <span className="sidebar-icon">{initials}</span>
      </div>

      <Link to="/parts" className="sidebar-item">
        <span className="sidebar-label">Partes</span>
        <span className="sidebar-icon">
          <FontAwesomeIcon icon={["fas", "tools"]} />
        </span>
      </Link>

      <Link to="/branches" className="sidebar-item">
        <span className="sidebar-label">Sucursales</span>
        <span className="sidebar-icon">
          <FontAwesomeIcon icon={["fas", "industry"]} />
        </span>
      </Link>

      <Link to="/invoices" className="sidebar-item">
        <span className="sidebar-label">Facturas</span>
        <span className="sidebar-icon">
          <FontAwesomeIcon icon={["fas", "receipt"]} />
        </span>
      </Link>

      {userType === 1 ? (
        <Link to="/eta" className="sidebar-item">
          <span className="sidebar-label">ETA</span>
          <span className="sidebar-icon">
            <FontAwesomeIcon icon={["far", "clock"]} />
          </span>
        </Link>
      ) : null}

      {userType === 1 ? (
        <Link to="/users" className="sidebar-item">
          <span className="sidebar-label">Usuarios</span>
          <span className="sidebar-icon">
            <FontAwesomeIcon icon={["fas", "user"]} />
          </span>
        </Link>
      ) : null}

      {userType === 1 ? (
        <Link to="/dashboard" className="sidebar-item">
          <span className="sidebar-label">Dashboard</span>
          <span className="sidebar-icon">
            <FontAwesomeIcon icon={["fas", "chart-pie"]} />
          </span>
        </Link>
      ) : null}

      {userType === 1 ? (
        <Link to="/groups" className="sidebar-item">
          <span className="sidebar-label">Grupos</span>
          <span className="sidebar-icon">
            <FontAwesomeIcon icon={["fas", "boxes"]} />
          </span>
        </Link>
      ) : null}

      <div className="sidebar-item" onClick={() => auth.clearAuth()}>
        <span className="sidebar-label">Cerrar Sesión</span>
        <span className="sidebar-icon">
          <FontAwesomeIcon icon={["fas", "power-off"]} />
        </span>
      </div>
    </div>
  );
};

export default Sidebar;
